import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons'

export const orderTotalHeaderIconDecider = (show: boolean) => {
    if(show){
        return faChevronUp
    }
    return faChevronDown
}